import React from "react";
import Img from "gatsby-image";

function replaceImageWithSharp(critical, sharpImageFiles, domNode) {
    const file = (sharpImageFiles || []).find(
        i =>
            i.childImageSharp &&
            domNode.attribs.src === `/content/media/${i.relativePath}`
    );
    if (!file) {
        throw new Error(`Unable to find image ${domNode.attribs.src}.`);
    }
    return <Img className="mx-auto" critical={critical} fluid={file.childImageSharp.fluid} />;
}

function replaceHeaderIdsForSinglePageManual(pageSlug, domNode) {
    domNode.attribs.id = pageSlug + "-" + domNode.attribs.id;
}

function replaceAnchorHrefsForSinglePageManual(pageSlug, domNode) {
    const href = domNode.attribs.href || "";
    if (href.indexOf("#") === 0) {
        domNode.attribs.href =
            "#" + pageSlug + "-" + domNode.attribs.href.substring(1);
    } else if (href.indexOf("./") === 0) {
        const [, page, inner] = href.split(/[\/#]/);
        domNode.attribs.href = "#" + page + (inner ? "-" + inner : "");
    }
}

function replaceAnchorHrefsForStandalonePage(prefix, language, domNode) {
    const href = domNode.attribs.href || "";
    if (href.indexOf("./") === 0) {
        domNode.attribs.href =
            "/" + language + (prefix ? "/" + prefix : "") + href.substring(1);
    }
}

export function buildReplaceForSinglePageManual(pageSlug, sharpImageFiles) {
    return {
        img: replaceImageWithSharp.bind(null, true, sharpImageFiles),
        h1: replaceHeaderIdsForSinglePageManual.bind(null, pageSlug),
        h2: replaceHeaderIdsForSinglePageManual.bind(null, pageSlug),
        h3: replaceHeaderIdsForSinglePageManual.bind(null, pageSlug),
        h4: replaceHeaderIdsForSinglePageManual.bind(null, pageSlug),
        h5: replaceHeaderIdsForSinglePageManual.bind(null, pageSlug),
        h6: replaceHeaderIdsForSinglePageManual.bind(null, pageSlug),
        a: replaceAnchorHrefsForSinglePageManual.bind(null, pageSlug),
    };
}

export function buildReplaceForStandalonePage(
    prefix,
    language,
    sharpImageFiles
) {
    return {
        img: replaceImageWithSharp.bind(null, false, sharpImageFiles),
        a: replaceAnchorHrefsForStandalonePage.bind(null, prefix, language),
    };
}
